import { gql } from "@apollo/client";

export const GET_DISTRIBUTION_SYSTEMS = gql`
  query DistributionSystems($systemId: Int!) {
    getDistributionSystemsBySystemId(systemId: $systemId) {
      distributionSystemId
      connectionType
    }
  }
`;

export const GET_GROUPED_SAMPLING_STATIONS = gql`
  query GroupedSamplingStation($systemId: Int!) {
    getGroupedSamplingStationBySystemId(systemId: $systemId) {
      systemId
      groupId
      groupName
      groupDetails {
        sourceId
        sourceName
        groupDetails
        systemNumber
        systemName
      }
    }
  }
`;

export const GET_PUMPING_STATIONS = gql`
  query PumpingStation($systemId: Int!) {
    getPumpingStationsBySystemId(systemId: $systemId) {
      systemId
      pumpingStationId
      pumpingStationName
      status
      statusReason
      capacity
      capacityUnit
      availabilityType
    }
  }
`;

export const GET_SERVICE_CONNECTIONS = gql`
  query ServiceConnection($systemId: Int!) {
    getInventoryServiceConnectionsBySystemId(systemId: $systemId) {
      systemId
      numberOfConnections
      meterSize
      meterType
      connectionType
    }
  }
`;

export const GET_SITE_VISIT_HISTORY = gql`
  query SiteVisitHistory($systemId: Int!) {
    getSiteVisitHistoryBySystemId(systemId: $systemId) {
      systemId
      visitDate
      reasonType
      notifiedDate
      inspectorName
      nextInspectionDate
    }
  }
`;

export const GET_SOURCES = gql`
  query Source($systemId: Int!) {
    getSourcesBySystemId(systemId: $systemId) {
      systemId
      facilityId
      sourceId
      sourceName
      status
      sourceType
      latitude
      longitude
      opDate
      waterType
      statusReason
      startDay
      startMonth
      endDay
      endMonth
      flows {
        facilityId
        flow
        flowRate
        flowUom
      }
      abandoned
    }
  }
`;

export const GET_TREATMENT_PLANTS = gql`
  query TreatmentPlants($systemId: Int!) {
    getInventoryTreatmentPlantsBySystemId(systemId: $systemId) {
      treatmentPlantId
      facilityId
      plantName
      status
      designCap
      flowRaeUom
      binType
      binStatus
      binDate
      treatmentPurpose {
        purpose
      }
    }
  }
`;

export const GET_STORAGE = gql`
  query Storage($systemId: Int!) {
    getStorageBySystemId(systemId: $systemId) {
      systemId
      storageId
      storageName
      storageType
      effectiveVolume
      effectiveVolumeUnit
      material
      status
      activityReason
    }
  }
`;